<script lang="ts">
    export let message: string = "Downloading...";
  </script>
  
  <div class="fixed inset-0 z-[200] flex items-center justify-center bg-black bg-opacity-40 backdrop-blur-sm">
    <div class="bg-white p-6 rounded-2xl shadow-2xl flex flex-col items-center animate-pop-in">
      <svg 
          class="animate-spin h-10 w-10 text-primary-500 mb-3" 
          xmlns="http://www.w3.org/2000/svg" 
          fill="none" 
          viewBox="0 0 24 24"
      >
        <circle 
          class="opacity-25" 
          cx="12" 
          cy="12" 
          r="10" 
          stroke="currentColor" 
          stroke-width="4"
        ></circle>
        <path 
          class="opacity-75" 
          fill="currentColor" 
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
      
      <span class="text-gray-700 font-medium text-sm">{message}</span>
    </div>
  </div>
  
  <style>
      /* Custom color if you don't have 'text-primary-500' in tailwind */
      .text-primary-500 { color: #3b82f6; /* Blue */ }
  
      .animate-pop-in {
          animation: popIn 0.2s ease-out;
      }
      @keyframes popIn {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
      }
  </style>